import React from "react";
import { useTranslation } from "react-i18next";
import {
    DetailsBlock,
    DetailsHeader,
    DetailsRow,
    Label,
    Value,
} from "src/components/ContinueDealerOffer/Pages/ReviewPage";
import { formatNumberAsPercentage, localizeCurrencyWithDecimals } from "src/utils";

interface Props {
    downPayment: number;
    downPaymentLabel?: string;
    lender?: string;
    rate?: number;
    term: number;
    amountFinanced: number;
}

const Loan = ({ downPayment, downPaymentLabel, lender, rate, term, amountFinanced }: Props) => {
    const { t } = useTranslation();

    return (
        <DetailsBlock>
            <DetailsHeader>{t("DealerOffer.ContinueDealerOffer.ReviewPage.Financing.Header")}</DetailsHeader>

            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.Financing.Lender")}</Label>
                <Value>{lender}</Value>
            </DetailsRow>

            <DetailsRow>
                <Label>
                    {downPaymentLabel ?? t("DealerOffer.ContinueDealerOffer.ReviewPage.Financing.DownPayment")}
                </Label>
                <Value>{localizeCurrencyWithDecimals(downPayment)}</Value>
            </DetailsRow>

            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.Financing.AmountFinanced")}</Label>
                <Value>{localizeCurrencyWithDecimals(amountFinanced)}</Value>
            </DetailsRow>

            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.Financing.InterestRate")}</Label>
                <Value>{formatNumberAsPercentage(rate)}</Value>
            </DetailsRow>

            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.Financing.Term")}</Label>
                <Value>{`${term} ${t("DealerOffer.ContinueDealerOffer.ReviewPage.Financing.TermMonths")}`}</Value>
            </DetailsRow>
        </DetailsBlock>
    );
};

export default Loan;
